export const eEnvironments = {
  local: 'local',
  dev: 'dev',
  qa: 'qa',
  stage: 'stage',
  prod: 'production'
};

export const eLogLevel = {
  TRACE: 'trace',
  DEBUG: 'debug',
  INFO: 'info',
  WARN: 'warn',
  ERROR: 'error'
};

export const eOddsFormats = {
  decimal: 'decimal',
  fractional: 'fractional',
  american: 'american'
};

export const ePublishers = {
  sportclient: 'sportclient',
  sportwrapper: 'ucf.sdk',
  weblogin: 'weblogin'
};

export const eChannels = {
  crm: 'crm',
  crosssell: 'crossSell',
  identity: 'identity',
  navigation: 'navigation',
  payments: 'payments',
  player: 'player',
  session: 'session',
  spinner: 'spinner',
  userinteraction: 'userinteraction',
  wallet: 'wallet',
  tracking: 'tracking'
};

export const eTopics = {
  crm: {
    CTA_ExternalLink_Open: 'CTA_ExternalLink_Open',
    CTA_RICH_Open: 'CTA_RICH_Open'
  },
  crosssell: {
    CTA_CasinoClient_Open: 'CTA_CasinoClient_Open',
    CTA_LiveDealer_Open: 'CTA_LiveDealer_Open',
    CTA_PokerClient_Open: 'CTA_PokerClient_Open',
    CTA_Vegas_Open: 'CTA_Vegas_Open'
  },
  identity: {
    authenticate: 'authenticate',
    getToken: 'getToken',
    initThirdParty: 'initThirdParty',
    logout: 'logout',
    userAuthenticationFailed: 'userAuthenticationFailed',
    userAuthenticationSucceeded: 'userAuthenticationSucceeded'
  },
  navigation: {
    Navigate: 'Navigate',
    changeBrowserURI: 'changeBrowserURI'
  },
  payments: {
    CTA_Cashier_Open: 'CTA_Cashier_Open'
  },
  player: {
    CTA_Bet_Failed: 'CTA_Bet_Failed',
    CTA_Login_Request_Submit: 'CTA_Login_Request_Submit',
    CTA_Logout_Request_Submit: 'CTA_Logout_Request_Submit',
    CTA_MyAccount_Open: 'CTA_MyAccount_Open',
    CTA_NRS_Open: 'CTA_NRS_Open',
    playerSegmentationUpdate: 'playerSegmentationUpdate',
    showBetslip: 'showBetslip',
    addToBetslip: 'addToBetslip'
  },
  session: {
    clientInitFailed: 'clientInitFailed',
    clientInitSucceeded: 'clientInitSucceeded',
    heartBeat: 'heartBeat',
    inactivityTimeout: 'inactivityTimeout',
    subscribedToMessageBroker: 'subscribedToMessageBroker'
  },
  userinteraction: {
    BurgerMenu_Toggle: 'BurgerMenu_Toggle'
  },
  wallet: {
    PlayerAction_BetSucceeded: 'PlayerAction_BetSucceeded'
  },
  spinner: {
    SetVisible: 'SetVisible'
  },
  tracking: { sendEvent: 'sendEvent' }
};

export const eInternalEvents = {
  KeepAliveSportProvider: 'KeepAliveSportProvider',
  ChannelsSentByWrapper: 'ChannelsSentByWrapper',
  NativeUXVersion: 'NativeUXVersion'
};

export const eCategoriesGA = {
  LeftSideNav: 'LeftSideNav',
  LeftSideNav_Category: 'LeftSideNav_Category',
  ListView_Right: 'ListView_Right',
  ListView: 'ListView',
  LiveRightNow: 'LiveRightNow',
  HomepageHRaces: 'HomepageHRaces',
  MobileRibbon: 'Mobile Ribbon',
  PopularStrip: 'Popular Sports',
  HomePageBanner: 'Homepage banner',
  EnhancedSpecials: 'enhancedspecials',
  Highlights: 'Highlights',
  Favor8: 'Favor8',
  RecommendedForYou: 'RForYou',
  EsportsHomepage: 'EsportsHomepage',
  Betslip: 'Betslip'
};

export const eActionsGA = {
  quickLinks: 'Quick Links',
  staticLinks: 'Static Links',
  sportCategories: 'Sport Categories',
  click: 'Click',
  deepLink: 'DeepLink',
  bet: 'Bet',
  expand: 'Expand',
  ViewEvent: 'ViewEvent',
  AddToBetslip: 'AddToBetslip',
  FollowTeam: 'FollowTeam',
  openDeposit: 'open deposit'
};

export const eTrackingEventsGTM = {
  clickstreamLogging: 'sc_clickstream_logging',
  gaEvent: 'sc_gaEvent'
};

export const eExternalContentComponents = {
  HOME_PAGE_BANNER: 'homePageBanner',
  HOME_PAGE_RIGHT_BANNER: 'homePageRightBanner',
  LIST_VIEW: 'listView'
};

export const eCrossSellLink = {
  casino: 'casino',
  poker: 'poker'
};

export const eRibbonCategories = {
  sport: 'sport',
  internalLink: 'internalLink',
  casinoCTA: 'casinoCTA'
};

export const eSportsRibbonElement = {
  MyBets: 'myBets',
  EnhancedSpecials: 'enhancedSpecials',
  Casino: 'casino',
  LiveNow: 'liveNow'
};

export const eCookies = {
  sportsRibbonRendered: 'sc_m_sports_ribbon_rendered'
};

export const eNavigationArrows = {
  NEXT: 'NEXT',
  PREV: 'PREV'
};

export const eSportIcons = {
  default: 'default',
  athletics: 'athletics',
  football: 'football',
  tennis: 'tennis',
  basketball: 'basketball',
  golf: 'golf',
  volleyball: 'volleyball',
  motorsports: 'motorsports',
  baseball: 'baseball',
  american_football: 'american_football',
  beach_volley: 'beach_volley',
  boxing: 'boxing',
  chess: 'chess',
  cricket: 'cricket',
  cycling: 'cycling',
  darts: 'darts',
  esports: 'esports',
  e_sport: 'e_sport',
  'e-sports': 'e-sports',
  horse_racing: 'horse_racing',
  ice_hockey: 'ice_hockey',
  field_hockey: 'field_hockey',
  rugby_league: 'rugby_league',
  rugby_union: 'rugby_union',
  snooker: 'snooker',
  surfing: 'surfing',
  tv___novelty: 'tv___novelty',
  ufc_mma: 'ufc_mma',
  winter_olympic_games: 'winter_olympic_games',
  winter_sports: 'winter_sports',
  olympic_games: 'olympic_games',
  gaelic_sports: 'gaelic_sports',
  netball: 'netball',
  politics: 'politics',
  trotting: 'trotting',
  water_polo: 'water_polo',
  australian_rules: 'australian_rules',
  handball: 'handball',
  '888': '888',
  '888_specials': '888_specials',
  home: 'home',
  liveRightNow: 'liveRightNow',
  live_now: 'live_now',
  startingSoon: 'startingSoon',
  popular: 'popular',
  betHistory: 'betHistory',
  badminton: 'badminton',
  table_tennis: 'table_tennis',
  more_sports: 'more_sports',
  blog: 'blog',
  sport_races: 'sport_races',
  bandy: 'bandy',
  floorball: 'floorball',
  wwe_pro_wrestling: 'wwe_pro_wrestling',
  'cyclo-cross': 'cyclo-cross',
  futsal: 'futsal',
  greyhounds: 'greyhounds',
  cool_arrow: 'cool_arrow',
  my_bets: 'my_bets',
  casino: 'casino'
};

export const eMessageTypesWS = {
  LIVE_EVENT_OPENED: 5,
  EVENT_REMOVED: 18,
  EVENT_SCORE_UPDATED: 16,
  EVENT_STATS_UPDATED: 17,

  BET_OFFER_ADDED: 6,
  BET_OFFER_REMOVED: 7,
  BET_OFFER_ODDS_ADDED: 22,
  BET_OFFER_ODDS_REMOVED: 23,
  BET_OFFER_ODDS_UPDATED: 11,
  BET_OFFER_STATUS_UPDATED: 8,

  MATCH_CLOCK_UPDATED: 15,
  MATCH_CLOCK_REMOVED: 12
};

export const EBetOfferTag = {
  /** The bet offer will be offered live. */
  OFFERED_LIVE: 'OFFERED_LIVE',
  /** The bet offer will be offered live. */
  OFFERED_PREMATCH: 'OFFERED_PREMATCH',
  /** The bet offer can not be combined with other bet offers when placing bets. It tag is omitted the bet offer can be combined with other bet offers. */
  NOT_COMBINABLE: 'NOT_COMBINABLE',
  /** The odds of the bet offer will be set during settling. The odds for this bet offer will be returned as -1. */
  STARTING_PRICE: 'STARTING_PRICE',
  /** The bet offer is the main bet offer within this event (one bet offer can be main for prematch and one can be main for live). */
  MAIN: 'MAIN',
  /** Rule 4 applies to the bet offer. See the official terms and conditions for the description of Rule 4. */
  RULE4: 'RULE4',
  /** Partial Bet Approval is not available for this bet offer. */
  PBA_DISABLED: 'PBA_DISABLED',
  /** The bet offer has enhanced place terms (horse racing).*/
  ENHANCED_PLACE_TERMS: 'ENHANCED_PLACE_TERMS',
  /** Indicates that the betOffer is in the Away @ Home format. */
  AMERICAN_DISPLAY_FORMAT: 'AMERICAN_DISPLAY_FORMAT',
  /** The bet offer has the most even odds of all with same criterion order. */
  MAIN_LINE: 'MAIN_LINE'
};

export const EEventTag = {
  /** The event will be offered live. */
  OFFERED_LIVE: 'OFFERED_LIVE',
  /** Event will be streamed to web clients. */
  STREAMED_WEB: 'STREAMED_WEB',
  /** Event will be streamed to mobile clients. */
  STREAMED_MOBILE: 'STREAMED_MOBILE',
  /** Event has statistics. */
  PREMATCH_STATS: 'PREMATCH_STATS',
  /** Event will have live visualization. */
  VISUALIZATION: 'VISUALIZATION',
  /** The event is open for live betting. */
  OPEN_FOR_LIVE: 'OPEN_FOR_LIVE',
  /** A hint for clients to show start number on participants. Mainly used in racing competitions. */
  SHOW_START_NUMBER: 'SHOW_START_NUMBER',
  /** The event is a match (usually between two participants). */
  MATCH: 'MATCH',
  /** The bet offer has enhanced place terms (horse racing).*/
  COMPETITION: 'COMPETITION',
  /** Indicates that the event is in the Away @ Home format. The name of the event is flipped (Away team first). */
  AMERICAN_DISPLAY_FORMAT: 'AMERICAN_DISPLAY_FORMAT'
};

export const ECashoutStatus = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
  SUSPENDED: 'SUSPENDED'
};

export const EOutcomeStatus = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
  SUSPENDED: 'SUSPENDED',
  SETTLED: 'SETTLED'
};

export const EEventState = {
  /** Before the event has started. */
  NOT_STARTED: 'NOT_STARTED',
  /** When the event has started but not yet been settled. */
  STARTED: 'STARTED',
  /** When the event is settled. */
  FINISHED: 'FINISHED',
  /** When event state is not known */
  UNKNOWN: 'UNKNOWN'
};

export const eParticipantRoles = {
  home: 'home',
  away: 'away'
};

export const eElasticEvent = {
  WindowOnLoad: 'SportClientWindowOnLoad',
  DOMContentLoaded: 'SportClientDomContentLoaded',
  KambiWidgetApiScriptStart: 'SportClientKambiWidgetScriptStart',
  KambiWidgetApiScriptEnd: 'SportClientKambiWidgetScriptEnd',
  KambiWidgetApiScriptReady: 'SportClientKambiWidgetScriptReady'
};

export const ePerformanceMark = {
  UserLoginStart: 'user-login-start'
};

export const ePerformanceMeasure = {
  WindowOnLoad: 'sport-client-dom-window-on-load',
  DOMContentLoaded: 'sport-client-dom-content-loaded',
  KambiWidgetApiScriptStart: 'kambi-widget-api-script-start',
  KambiWidgetApiScriptEnd: 'kambi-widget-api-script-end',
  KambiWidgetApiScriptReady: 'kambi-widget-api-script-ready'
};
